(() => {
  const root = document.documentElement;
  const reveal = async device => {
    if (!device) {
      root.classList.remove('anr-retro-pending');
      return;
    }
    const frameImage = device.querySelector('.anr-device__frame');
    if (frameImage?.decode) {
      await Promise.race([
        frameImage.decode().catch(() => {}),
        new Promise(resolve => setTimeout(resolve, 5500))
      ]);
    }
    device.classList.add('anr-device--ready');
    root.classList.remove('anr-retro-pending');
  };

  if (window.Shopify?.designMode || root.classList.contains('shopify-design-mode')) {
    document.querySelectorAll('.anr-device').forEach(device => device.classList.add('anr-device--ready'));
    root.classList.remove('anr-retro-pending');
    return;
  }

  const home = document.querySelector('[data-anr-home]');
  if (home) {
    root.classList.add('anr-retro-lock');
    const boot = home.querySelector('[data-anr-boot]');
    const content = home.querySelector('[data-anr-content]');
    const links = [...home.querySelectorAll('.anr-machine__channels a')];
    const screen = home.querySelector('.anr-device__screen');
    let signalTimer;
    const tune = () => {
      if (!screen) return;
      clearTimeout(signalTimer);
      screen.classList.remove('anr-crt-tuning');
      void screen.offsetWidth;
      screen.classList.add('anr-crt-tuning');
      signalTimer = setTimeout(() => screen.classList.remove('anr-crt-tuning'), 420);
    };
    const open = () => {
      if (!boot || !content) return;
      tune();
      boot.hidden = true;
      content.hidden = false;
      screen.scrollTop = 0;
      links[0]?.focus({ preventScroll: true });
    };
    const close = () => {
      if (!boot || !content) return;
      tune();
      content.hidden = true;
      boot.hidden = false;
      screen.scrollTop = 0;
      boot.querySelector('[data-anr-start]')?.focus({ preventScroll: true });
    };
    home.querySelectorAll('[data-anr-start],[data-anr-open]').forEach(button => button.addEventListener('click', open));
    home.querySelectorAll('[data-anr-stop]').forEach(button => button.addEventListener('click', close));
    home.addEventListener('keydown', event => {
      if (content?.hidden || !links.includes(document.activeElement)) return;
      const index = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') { event.preventDefault(); links[(index + 1) % links.length].focus(); }
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') { event.preventDefault(); links[(index - 1 + links.length) % links.length].focus(); }
      if (event.key === 'Escape') { event.preventDefault(); close(); }
    });
    reveal(home);
    return;
  }

  const main = document.querySelector('#MainContent');
  const template = document.querySelector('template[data-anr-retro-loader]');
  if (!main || !template || document.querySelector('.anr-route-frame')) {
    root.classList.remove('anr-retro-pending');
    return;
  }
  const frame = template.content.firstElementChild?.cloneNode(true);
  const mount = frame?.querySelector('.anr-route-frame__mount');
  if (!mount) {
    root.classList.remove('anr-retro-pending');
    return;
  }
  const title = document.title.replace(/\s*[|–—-]\s*AntiNRML.*$/i, '').trim() || 'AntiNRML';
  const label = frame.querySelector('.anr-route-frame__title');
  if (label) label.textContent = title;
  main.parentNode.insertBefore(frame, main);
  mount.append(main);
  const footer = document.querySelector('.page-wrapper > footer');
  if (footer) mount.append(footer);
  root.classList.add('anr-retro-route', 'anr-retro-lock');
  reveal(frame);

  const cartLink = frame.querySelector('.anr-route-frame__hud a[href*="/cart"]');
  const refreshCartCount = async () => {
    if (!cartLink) return;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (Number.isInteger(cart.item_count)) cartLink.textContent = `CART (${cart.item_count})`;
    } catch (_) {}
  };
  main.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button || !/add to cart|remove|increase quantity|decrease quantity/i.test(button.getAttribute('aria-label') || button.textContent)) return;
    setTimeout(refreshCartCount, 700);
    setTimeout(refreshCartCount, 1800);
  });
  if (location.pathname.startsWith('/cart')) {
    let cartTimer;
    new MutationObserver(() => {
      clearTimeout(cartTimer);
      cartTimer = setTimeout(refreshCartCount, 300);
    }).observe(main, { childList: true, subtree: true });
  }
})();
